import { CartItem, usePostTariffEstimate } from "../portal-apps"
import { useEffect, useMemo, useRef, useState } from "react"

export const useGetTariffs = (cart: CartItem[], calculateTariffs: boolean, customerId: string) => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState<string | null>(null)
	const [estimate, setEstimate] = useState(0)
	const fetchTariffEstimate = usePostTariffEstimate()

	const lastPayloadRef = useRef<string | null>(null)

	const lineItems = useMemo(() => {
		return cart.map((item) => ({
			part_number: item.part.part.partNumber,
			amount: item.part.netPrice,
			quantity: item.quantity,
		}))
	}, [cart])

	const payload = useMemo(() => {
		if (lineItems.length === 0) return null
		const payload: any = {
			lines: lineItems,
		}
		if (customerId) {
			payload.customerId = customerId
		}
		return payload
	}, [lineItems, customerId])

	useEffect(() => {
		if (!payload || !calculateTariffs) return
		const payloadStr = JSON.stringify(payload)
		if (lastPayloadRef.current === payloadStr) {
			return
		}
		lastPayloadRef.current = payloadStr

		const getTariffEstimate = async () => {
			setIsLoading(true)
			setError(null)

			try {
				const response = await fetchTariffEstimate(payload)
				setEstimate(response.data?.tariff_estimate ?? 0)
			} catch (_error) {
				setError("Failed to fetch tariff estimate")
			} finally {
				setIsLoading(false)
			}
		}
		void getTariffEstimate()
	}, [fetchTariffEstimate, payload])

	return { isLoading, error, estimate }
}
